export default class ItemIndex {
  constructor() { }

  initialize() {
    
  }
}